import { Content } from './items.styled';
import { Item } from './item';
import { getItems } from './items.func';

export const Items = (props) => {
  const { event } = props;
  const { data } = event;
  const node = window.config.nodes[event.source];
  const nodeType = node?.rack_type;

  /**
   * get foto items elements
   * @param {*} items
   * @returns
   */
  const getItemsEl = () => {
    const items = getItems(nodeType, data, data.photo_stay, data.vehicle_plate_stay);
    return items.map((el, idx) => {
      return <Item key={idx} item={el} source={event.source} id={event.id} />;
    });
  };

  const itemsEl = getItemsEl();

  return <Content>{itemsEl}</Content>;
};
